import React from 'react';

const Chat = ({ onLogout }) => {
  return (
    <div>
      <h1>Chat</h1>
      <p>Chat feature coming soon.</p>
      {onLogout && (
        <button type="button" onClick={onLogout}>
          Log out
        </button>
      )}
    </div>
  );
};

export default Chat;
